<template>
  <div class="login-container">
    <div class="login-form">
      <div class="login-top">
        <img src="@/assets/subscription-types/solarfox.png" alt="Logo" class="logo">
        <h2>Welcome, please login</h2>
      </div>
      <form @submit.prevent="doubleCheckUser">
        <div class="form-group">
          <label for="order-id">Order-ID(XXXXXX-XXXXXXXXXX):</label>
          <input type="text" id="order-id" v-model="orderId" placeholder="Enter Order-ID" required>
        </div>
        <div class="form-group">
          <label for="email">E-Mail:</label>
          <input type="email" id="email" v-model="email" placeholder="Enter E-Mail" required>
        </div>
        <div class="form-group">
          <label for="zip">ZIP (Postal Code):</label>
          <input type="text" id="zip" v-model="zip" placeholder="Enter ZIP" required>
        </div>
        <button class="button" type="submit" :disabled="loading">
          <span v-if="loading">
            <div class="spinner"></div>
          </span>
          <span v-else>Login</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from "axios";

export default {
  created() {
    this.$store.commit('initializeFailedAttempts');
    this.$store.commit('initializeBlockedUntil');
  },
  data() {
    return {
      orderId: '',
      email: '',
      zip: '',
      loading: false
    };
  },
  computed: {
    ...mapState({
      userExists: state => state.userExists,
      customerId: state => state.customerId,
      subscriptionOrderToken: state => state.subscriptionOrderToken,
      failedAttempts: state => state.failedAttempts,
      lastFailedAttemptTime: state => state.lastFailedAttemptTime,
      maxAttempts: state => state.maxAttempts,
      blockedUntil: state => state.blockedUntil,
    })
  },
  methods: {
    ...mapActions([
      'incrementFailedAttempts',
      'resetFailedAttempts',
      'updateLastFailedAttemptTime',
      'updateBlockedUntil'
    ]),
    submitForm() {
      this.$router.push(`/subscription/info?customer_id=${this.customerId}&order_id=${this.orderId}&subscription_access_token=${this.subscriptionOrderToken}`);
      this.resetFailedAttempts();
    },
    async doubleCheckUser() {
      if (this.isBlocked()) {
        this.$store.dispatch("changeErrorMsg", {
          msg: "You have exceeded the maximum number of failed login attempts. Please try again in 30 min.",
          type: "negativ",
        });
        return false;
      }
      this.loading = true;
      let CheckData = {
        orderId: this.orderId,
        email: this.email,
        zip: this.zip,
        cancelToken: axios.CancelToken.source(),
      }
      this.$store.dispatch('doubleCheckUser', CheckData)
          .then(() => {
            if (this.userExists) {
              this.submitForm()
            } else {
              this.incrementFailedAttempts();
              this.updateLastFailedAttemptTime(Date.now());
              this.$store.dispatch("changeErrorMsg", {
                msg: "Oops! It seems there's an issue. Please double-check your order-ID, ZIP, and email address. You have " + (this.maxAttempts - this.failedAttempts) + " attempts remaining before we temporarily block further attempts. Thank you for your understanding.",
                type: "negativ",
              });
              return false;
            }
          })
          .catch(error => {
            console.error('Error:', error);
          })
          .finally(() => {
            this.loading = false;
          });
    },
    isBlocked() {
      const { failedAttempts, maxAttempts, blockedUntil } = this.$store.state;
      if (failedAttempts >= maxAttempts) {
        if (blockedUntil && Date.now() < blockedUntil) {
          return true;
        } else {
          const newBlockedUntil = Date.now() + 30 * 60 * 1000;
          this.$store.commit('updateBlockedUntil', newBlockedUntil); // Update Vuex state with blockedUntil timestamp
          return true;
        }
      }
      return false;
    },
  }
}
</script>


<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.logo {
  width: 100px; /* Adjust size as needed */
}

.login-form {
  max-width: 500px;
  width: 100%;
  padding: 20px 20px 35px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
}
.login-top {
  width: 100%;
  height: 100%;
  display: block;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.login-top image {
  display: flex;
}
.form-group {
  margin-bottom: 20px;
}
h2 {
  text-align: center;
  color: #333;
}

label {
  display: block;
  margin-bottom: 5px;
  color: #333;
}

input[type="text"],
input[type="email"] {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #ffc107; /* Yellow theme color */
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 5px;
}
.button {
  display: flex;
  align-items: center;
  justify-content: center;
}

button:hover {
  background-color: #ffca2b; /* Darker shade of yellow on hover */
}
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #ffc107; /* Yellow theme color */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite; /* Animation */
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
